import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import "../assets/css/--component-billing-pricing.css"
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';


const TrialAlert = () => {
  const { daysRemaining } = useAppContext();
  const daysLeft = daysRemaining;
  const totalDays = 14;
  const history = useNavigate();

  return (
    <div className="p-3 rounded-3 mb-4 d-flex align-items-center justify-content-between trial-container">
      <Row className="w-100 align-items-center">
        <Col xs="12" md="10" className="d-flex align-items-center gap-3">
          <div className="bg-white text-danger rounded p-2 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
            <i className="ri-hourglass-fill fs-22"></i>
          </div>
          <div>
            <h6 className="fw-500 fs-22 mb-1">{daysLeft < 1 ? "Trial Ended" : `${daysLeft} Days Left in Your Trial`}</h6>
            <p className="mb-0 fs-14 text-dark">
              You are on a {totalDays}-day trial - <span className="text-danger fw-bold">{daysLeft}</span> days remaining. You can make up to 10 calls with a total duration of 10 minutes. Love the experience? Upgrade now to stay uninterrupted.
            </p>
          </div>
        </Col>
        <Col xs="12" md="2" className="d-flex justify-content-md-end mt-2 mt-md-0">
          <Button className="rounded px-3 fw-500 text-dark bg-white border-0" onClick={() => history('/pricing-plans')}>
            Select a Plan
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TrialAlert;
